<template>
  <div
    class="row"
    @dragover="preventDefault"
    @drop.prevent="fileDropped"
    @dragleave="preventDefault"
  >
    <ProjectUploadProgress />
    <div class="container-fluid mb-3">
      <div class="row g-3 m-0">
        <InvisibleUploadForm />
        <div class="col-12 col-md-9 left-panel">
          <div class="card h-100">
            <div class="card-header text-bg-success" />
            <div class="card-body">
              <UploadProjectBoarding :applications="applications" />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 right-panel">
          <div class="card h-100">
            <div class="card-header text-bg-dark" />
            <div class="card-body">
              <div class="row">
                <h5 class="text-center" v-html="$t('NewProject.interestedInSupply')" />
                <div class="col col-sm-12">
                  <div
                    v-if="!inProgress && !loading"
                    class="text-center py-3"
                  >
                    <a class="btn btn-lg btn-info" @click="convertToSupply">
                      {{ $t('NewProject.createPartsList') }}
                    </a>
                  </div>

                  <p class="text-center" v-html="$t('NewProject.supplyNotice')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadProjectBoarding from 'components/newProject/ProjectBoardingUpload.vue';
import ProjectUploadProgress from 'components/newProject/ProjectUploadProgress.vue';
import InvisibleUploadForm from 'components/newProject/InvisibleUploadForm.vue';
import messages from 'locales/NewProject';
import { postRequest } from 'helper/request';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { pageUrl } from 'helper/clientDetails';

export default {
  name: 'NewProject',
  components: {
    UploadProjectBoarding,
    ProjectUploadProgress,
    InvisibleUploadForm,
  },
  props: {
    applications: Array,
    supplyConversionPath: String,
  },
  computed: {
    ...mapState(['inProgress']),
    ...mapFields(['loading']),
  },
  methods: {
    ...mapActions(['upload']),
    async convertToSupply() {
      this.loading = true;
      await postRequest(this.supplyConversionPath);
      window.location.reload();
    },
    fileDropped(evt) {
      window.plausible('onboarding_upload', { u: pageUrl(), props: { method: 'drop' } });
      this.upload(Array.from(evt.dataTransfer.files));
    },
    preventDefault(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    },
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>
</style>
